import { render, staticRenderFns } from "./CompanyTabPeople.vue?vue&type=template&id=36fc7faa&scoped=true&"
import script from "./CompanyTabPeople.vue?vue&type=script&lang=js&"
export * from "./CompanyTabPeople.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTabPeople.vue?vue&type=style&index=0&id=36fc7faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fc7faa",
  null
  
)

export default component.exports